import type { ReactNode } from 'react'

import { Button } from 'antd'
import type { ButtonProps } from 'antd'
import cx from 'classnames'

export type IconButtonProps = Omit<ButtonProps, 'icon' | 'iconPosition'> & {
  icon?: ReactNode
  iconPosition?: 'left' | 'right'
  label?: ReactNode
  labelClassName?: string
  iconClassName?: string
  uppercase?: boolean
}

export function IconButton({
  icon,
  iconPosition = 'left',
  label,
  children,
  className,
  labelClassName,
  iconClassName,
  uppercase,
  loading,
  ...rest
}: IconButtonProps): JSX.Element {
  const content = children ?? label
  const isLoading = typeof loading === 'object' ? true : Boolean(loading)
  const shouldRenderIcon = icon && !isLoading
  const contentClasses = cx('leading-none', uppercase && 'uppercase tracking-wide', labelClassName)
  const iconClasses = cx(
    'flex items-center justify-center leading-none text-inherit [&>svg]:!align-middle [&>svg]:!text-current',
    iconClassName
  )

  return (
    <Button
      {...rest}
      loading={loading}
      className={cx(
        '!inline-flex !items-center !justify-center gap-2',
        iconPosition === 'right' && '!flex-row-reverse',
        className
      )}
    >
      {shouldRenderIcon && <span className={iconClasses}>{icon}</span>}
      {content && <span className={contentClasses}>{content}</span>}
    </Button>
  )
}

export default IconButton
